"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _excluded = ["dataMetrics"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultProps = {
  component: 'div',
  dataMetrics: {
    root: 'fuse_form_control'
  },
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false,
  variant: 'standard'
};

/**
 * Provides context such as error/required for form inputs. Relying on the context provides high flexibility and ensures that the state always stays consistent across the children of the FormControl.
 * This context is used by the following components:
 * - FormLabel
 * - FormHelperText
 * - Input
 */

var FormControl = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var dataMetrics = _ref.dataMetrics,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], (0, _extends2["default"])({
    "data-metrics": mergedDataMetrics.root,
    ref: ref
  }, rest));
});
FormControl.displayName = 'FormControl';
FormControl.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/form-control/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * If `true` the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If `true` the label should be displayed in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * If `true` the component will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes["default"].oneOf(['none', 'dense', 'normal']),
  /**
   * If `true` the label will indicate that the input is required.
   */
  required: _propTypes["default"].bool,
  /**
   * @ignore
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['standard', 'outlined', 'filled'])
} : {};
FormControl.defaultProps = defaultProps;
var _default = FormControl;
exports["default"] = _default;